import * as React from "react";
import classNames from "classnames";
import Button from "@material-ui/core/Button";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import CloseIcon from "@material-ui/icons/Close";
import green from "@material-ui/core/colors/green";
import amber from "@material-ui/core/colors/amber";
import IconButton from "@material-ui/core/IconButton";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import WarningIcon from "@material-ui/icons/Warning";
import { withStyles } from "@material-ui/core/styles";
export enum TypeOfMessage {
  error = "error",
  warning = "warning",
  info = "info",
  success = "success"
}
const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon
};
const styles = {
  wrapMes: {
    maxWidth: "100%",
    margin: "15px 0px",
    padding: "0px 20px",
    textTransform: "capitalize",
    fontWeight: "bold",
    fontSize: 13,
    flexWrap: "unset"
  }
};
const styles1 = theme => ({
  success: {
    backgroundColor: green[600]
  },
  error: {
    backgroundColor: theme.palette.error.dark
  },
  info: {
    backgroundColor: theme.palette.primary.dark
  },
  warning: {
    backgroundColor: amber[700]
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit
  },
  message: {
    display: "flex",
    alignItems: "center"
  }
});

class MySnackbarContent extends React.Component<any> {
  render() {
    const {
      classes,
      className,
      message,
      onClose,
      variant,
      ...other
    } = this.props;
    const Icon = variantIcon[variant];

    return (
      <SnackbarContent
        className={classNames(classes[variant], className)}
        style={styles.wrapMes}
        aria-describedby="client-snackbar"
        message={
          <span id="client-snackbar" className={classes.message}>
            <Icon className={classNames(classes.icon, classes.iconVariant)} />
            {message}
          </span>
        }
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            className={classes.close}
            onClick={onClose}
          >
            <CloseIcon className={classes.icon} />
          </IconButton>
        ]}
        {...other}
      />
    );
  }
}

const MySnackbarContentWrapper = withStyles(styles1)(MySnackbarContent);

const styles2 = theme => ({});

class CustomizedSnackbars extends React.Component {
  state = {
    open: true
  };

  handleClick = () => {
    this.setState({ open: true });
  };

  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ open: false });
  };

  render() {
    const { classes, Message, type, isShowPopup } = this.props;

    return (
      <div>
        {this.state.open &&
          Message &&
          (isShowPopup ? (
            <Snackbar
              {...this.props}
              open={this.state.open}
              onClose={this.handleClose}
            >
              <MySnackbarContentWrapper
                onClose={this.handleClose}
                variant={type ? type : TypeOfMessage.success}
                message={Message}
                className={classes.margin}
              />
            </Snackbar>
          ) : (
            <MySnackbarContentWrapper
              variant={type ? type : TypeOfMessage.success}
              className={classes.margin}
              message={Message}
              open={this.state.open}
              onClose={this.handleClose}
            />
          ))}
      </div>
    );
  }
}

export default withStyles(styles2)(CustomizedSnackbars);
